import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@evergis/ui";
import { ResourceTypeLink } from "@evergis/api";

import { useCopyResourceDialog } from "../../../hooks/useDialogs";
import { useLimitsExceededCheck } from "../../../hooks/useLimitsExceededCheck";

interface CopyIconProps {
  disabled?: boolean;
  name?: string;
}

export const CopyIcon: FC<CopyIconProps> = ({ disabled, name }) => {
  const { t } = useTranslation("common");
  const openCopyResourceDialog = useLimitsExceededCheck(useCopyResourceDialog());

  const openDialog = useCallback(
    () => openCopyResourceDialog([name, ResourceTypeLink.Layer], { fromTable: true }),
    [name, openCopyResourceDialog],
  );

  return <IconButton kind={"copy"} title={t("actions.copy")} disabled={disabled} onClick={openDialog} />;
};
